var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"loading":_vm.loading}},[_c('v-row',[_c('v-col',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('PurchaseItemList',{attrs:{"purchase-items":_vm.purchaseItems,"contract":{ id: _vm.contract.id, number: _vm.contract.number }}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }